// extracted by mini-css-extract-plugin
export default {"rating":"fz-z","numberOfStars":"gz-z","count":"hz-z","barGraphSpacing":"iz-z","barGraph":"jz-z"};